import React from 'react'
import { Link } from 'react-router-dom'
import LanguageToggle from './LanguageToggle'
import interactiveBusinessLogo from '../Logo/InteractiveBusinessLogo.svg'
import { buildContactHref } from '../lib/contactEmail'

const About = () => {
  const contactHref = buildContactHref()

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-20 sm:px-6 flex items-center justify-center">
      <div className="absolute top-4 left-4 sm:top-6 sm:left-6">
        <img
          src={interactiveBusinessLogo}
          alt="Interactive Business logo"
          className="h-12 w-auto sm:h-14"
        />
      </div>

      <div className="absolute top-4 right-4 flex items-center gap-4">
        <Link
          to="/login"
          className="text-base font-medium text-[#FF1B54] transition-colors hover:text-[#E1174C]"
        >
          Sign In
        </Link>
        <LanguageToggle />
      </div>

      <div className="w-full max-w-4xl rounded-2xl border border-[#FFD1DD] bg-white p-8 shadow-sm sm:p-12">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#FF1B54]">
            About Interactive Business
          </p>
          <h1 className="mt-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            A smarter way to understand, track, and improve business performance.
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Interactive Business is a SaaS platform designed to help business owners turn
            everyday numbers into clear financial insight. Customers can track revenue,
            expenses, leads, and performance trends, while administrators can oversee
            accounts, monitor progress, and support growth from one place.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-3">
          <div className="rounded-xl bg-[#FFF5F8] p-6">
            <h2 className="text-lg font-semibold text-gray-900">For Growing Businesses</h2>
            <p className="mt-3 text-sm leading-6 text-gray-600">
              Keep a pulse on key metrics with dashboards that make it easier to spot
              opportunities and understand performance over time.
            </p>
          </div>
          <div className="rounded-xl bg-[#FFF5F8] p-6">
            <h2 className="text-lg font-semibold text-gray-900">For Business Tracking</h2>
            <p className="mt-3 text-sm leading-6 text-gray-600">
              Customers can track their revenue, expenses, leads, and performance trends
              from one place with clear, real-time visibility.
            </p>
          </div>
          <div className="rounded-xl bg-[#FFF5F8] p-6">
            <h2 className="text-lg font-semibold text-gray-900">For Better Decisions</h2>
            <p className="mt-3 text-sm leading-6 text-gray-600">
              Use guided scorecards, expense views, and performance summaries to make
              informed choices with confidence.
            </p>
          </div>
        </div>

        <div className="mt-8 flex justify-end">
          <a
            href={contactHref}
            className="inline-flex items-center rounded-md bg-[#FF1B54] px-5 py-3 text-sm font-medium text-white transition-colors hover:bg-[#E1174C] focus:outline-none focus:ring-2 focus:ring-[#FF1B54] focus:ring-offset-2"
          >
            Contact us
          </a>
        </div>
      </div>
    </div>
  )
}

export default About
